import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { ClickAwayListener } from "@mui/material";
import './TextRangeDatePicker.scss';

const TextRangeDatePicker = ({
  startDate = new Date(),
  endDate = new Date(),
  setStartDate,
  setEndDate,
  hideDropdownIndicators = false,
}) => {
  const [isStartDateOpen, setIsStartDateOpen] = useState(false);
  const [isEndDateOpen, setIsEndDateOpen] = useState(false);

  const handleStartDateChange = (date) => {
    if (date && date <= endDate) {
      setStartDate(date);
    }
  };

  const handleEndDateChange = (date) => {
    if (date && date >= startDate) {
      setEndDate(date);
    }
  };

  const toggleStartDatePicker = () => {
    setIsStartDateOpen(!isStartDateOpen);
    setIsEndDateOpen(false);
  };

  const toggleEndDatePicker = () => {
    setIsEndDateOpen(!isEndDateOpen);
    setIsStartDateOpen(false);
  };

  const handleClickAway = () => {
    setIsStartDateOpen(false);
    setIsEndDateOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
    <div className="text-date-picker-container">
      <div className="text-date-picker-text">
        <div className="start-date-display" onClick={toggleStartDatePicker}>
          {format(startDate, "MMM dd yyyy")}
          {!hideDropdownIndicators && (
            <i className={`datepicker-caret bi-chevron-${isStartDateOpen ? 'up' : 'down'}`}/>
          )}
        </div>
        <span> -</span>
        <div className="end-date-display" onClick={toggleEndDatePicker}>
          {format(endDate, "MMM dd yyyy")}
          {!hideDropdownIndicators && (
            <i className={`datepicker-caret bi-chevron-${isEndDateOpen ? 'up' : 'down'}`}/>
          )}
        </div>
      </div>
      {isStartDateOpen && (
        <div className="datepicker-wrapper">
          <div className="start-date-picker">
            <DatePicker
              selected={startDate}
              onChange={handleStartDateChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              inline
              maxDate={new Date()}
            />
          </div>
        </div>
      )}
      {isEndDateOpen && (
        <div className="datepicker-wrapper">
          <div className="end-date-picker">
            <DatePicker
              selected={endDate}
              onChange={handleEndDateChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              maxDate={new Date()}
              inline
            />
          </div>
        </div>
      )}
    </div>
    </ClickAwayListener>
  );
};

export default TextRangeDatePicker;
